import { createFileRoute } from '@tanstack/react-router';

import { ActivatePage } from '../modules/auth/ui/pages/ActivatePage';

export const Route = createFileRoute('/activate/$token')({
  component: ActivatePage,
});
